import React from "react";
import { Badge, Offcanvas } from "react-bootstrap";
import './RightModelHealth.css';

const getStatusVariant = (statusCode: number) => {
    if (statusCode >= 200 && statusCode < 300) return "success"; // green
    if (statusCode >= 300 && statusCode < 400) return "warning"; // yellow
    if (statusCode >= 400 && statusCode < 500) return "orange";  // custom
    if (statusCode >= 500 && statusCode < 600) return "danger";  // red
    return "secondary";
};

const RightModelHealth: React.FC<any> = ({ show, onClose, data, title = "Endpoint Status Details" }) => {
    return (
        <Offcanvas show={show} onHide={onClose} placement="end" className="rag-offcanvass" style={{width: '700px !important'}}>
            <Offcanvas.Header closeButton className="rag-header">
                <div>
                    <h5 className="rag-title">{data?.model || "..."}</h5>
                    <p className="rag-subtitle">{title}</p>
                </div>
            </Offcanvas.Header>

            <Offcanvas.Body className="rag-body">

                {data && (
                    <>
                        {/* Basic Details */}
                        <section className="rag-section">
                            <div className="rightmodel-details-grid">
                                <div className="rightmodel-detail-item">
                                    <span className="rightmodel-label">Model Provider</span>
                                    <span className="rightmodel-value">{data?.model_provider}</span>
                                </div>
                                <div className="rightmodel-detail-item">
                                    <span className="rightmodel-label">Endpoint URL</span>
                                    <span className="rightmodel-value">{data?.endpoint_url}</span>
                                </div>
                                <div className="rightmodel-detail-item">
                                    <span className="rightmodel-label">Status</span>
                                    <span className="rightmodel-value">
                                        <Badge bg={getStatusVariant(data?.status_code)} className="status-pill">
                                            {data?.status_code}
                                        </Badge>
                                    </span>
                                </div>
                                <div className="rightmodel-detail-item">
                                    <span className="rightmodel-label">Last Updated</span>
                                    <span className="rightmodel-value">{new Date(data?.last_data_refreshed_at).toLocaleString()}</span>
                                </div>

                                {/* Health Bar */}
                                <section className="mt-4">
                                    <h6 className="section-titles">Last 24hrs Health</h6>
                                    <div className="health-bar">
                                        {data?.health_last_24h.map((h: string, idx: number) => (
                                            <span
                                                key={idx}
                                                className={`health-block ${h === "up" ? "up" : "down"}`}
                                            />
                                        ))}
                                    </div>
                                </section>

                                {/* Failure History */}
                                <section className="mt-4">
                                    <h6 className="section-titles m-0">Failure History</h6>
                                    <small>Last 5 failure status and summary</small>
                                    <div className="failure-table">
                                        <div className="failure-header">
                                            <span>Status</span>
                                            <span>Response Summary</span>
                                            <span>Time Stamp</span>
                                        </div>

                                        {data?.failure_history?.map((f: any, idx: number) => (
                                            <div key={idx} className="failure-row">
                                                <Badge bg={getStatusVariant(f.status_code)} className="failure-status-badge">{f.status_code}</Badge>
                                                <span className="response_summary">{f.response_summary}</span>
                                                <span>
                                                    {new Date(f.timestamp).toLocaleString()}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </section>

                            </div>
                        </section>

                    </>
                )}

                {!data && (
                    <div className="text-center py-4 text-muted">No Data available</div>
                )}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default RightModelHealth;
